module.exports = __webpack_public_path__ + "static/BuenosAiresWeb-Bold-a635a0d91af4d5187318119abc88b279.woff2";